/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { Asset, AssetMediaType, EntryPoint } from '@wit/vtv-x-foundation-lib';
import { PrivateRoutePath, RoutePath, StartUpRoutePath } from 'routes/paths';
import translate from 'services/i18n/translate';
import { FolderInfoContext, ParentContext } from 'store/ducks/folderInfo';
import MainSection from 'types/MainSection';

export default class RouterUtils {
  /**
   * @deprecated use 'useRouter'
   */
  static getRouteWithDynamicValues(path: RoutePath, valuesSeries: unknown[]): string {
    if (!Array.isArray(valuesSeries)) {
      return StartUpRoutePath.ROOT;
    }

    const valuesSeriesCopy = [...valuesSeries];
    const pathSplited = path.split('/');

    return pathSplited.reduce((acc, currentValue) => {
      if (!currentValue) {
        return acc;
      }

      if (currentValue[0] !== ':') {
        return `${acc}/${currentValue}`;
      }

      const valueToAdd = valuesSeriesCopy.shift();

      if (!valueToAdd) {
        return acc;
      }

      return `${acc}/${valueToAdd}`;
    }, '');
  }

  /**
   * @deprecated use 'useRouter'
   */
  static getAssetInfoRoute(section: MainSection, asset: Asset, entryPoint?: EntryPoint): string {
    const valuesSeries: (number | MainSection | AssetMediaType | EntryPoint)[] = [section, asset.mediaType, asset.id];

    if (entryPoint) {
      valuesSeries.push(entryPoint);
    }

    return RouterUtils.getRouteWithDynamicValues(PrivateRoutePath.PROGRAM_INFO, valuesSeries);
  }

  static getBackDetails(
    section: MainSection,
    context?: FolderInfoContext,
    parentContext?: ParentContext
  ): { backLabel: string; backUrl?: string } {
    if (context?.entryAsset && parentContext && parentContext.entryAsset) {
      return {
        backLabel: translate.back,
        backUrl: RouterUtils.getAssetInfoRoute(section, parentContext.entryAsset, parentContext.entryPoint),
      };
    }

    switch (section) {
      case MainSection.MY_TV:
        return { backLabel: translate['menu.myTv'], backUrl: PrivateRoutePath.MYTV };
      case MainSection.WATCH_TV:
        return { backLabel: translate['menu.watchTv'], backUrl: PrivateRoutePath.WATCHTV };
      case MainSection.ONDEMAND:
      default:
        return { backLabel: translate['menu.onDemand'], backUrl: PrivateRoutePath.ONDEMAND };
    }
  }
}
